export const renderHTML = (htmlString: string) => {
  return <span dangerouslySetInnerHTML={{ __html: htmlString }} />;
};
